import {Grid, GridProps} from "@mantine/core";
import {ObjectChangeLogDataTable} from "../../../data-table/ObjectChangeLogDataTable/ObjectChangeLogDataTable";
import {useMemo} from "react";
import {
  Entity,
  ObjectChangeLogEntry,
  objectChangeLogsSelector,
  useGetObjectChangeLogsByObjectQuery
} from "@ots-frontend/ots-data";

export type ObjectChangeLogViewProps = Omit<GridProps, 'children'> & {
  entity: Entity
}

export const ObjectChangeLogView = (props: ObjectChangeLogViewProps) => {
  const {
    entity,
    ...rest
  } = props

  const selectObjectChangeLogs = useMemo(() => {
    return objectChangeLogsSelector();
  }, []);

  const {objectChangeLogs, isLoading, isFetching} = useGetObjectChangeLogsByObjectQuery({
    id: entity.id,
    type: entity.entityType,
  }, {
    selectFromResult: (result) => ({
      objectChangeLogs: selectObjectChangeLogs(result),
      isLoading: result.isLoading,
      isFetching: result.isFetching,
    })
  });

  const objectChangeLogEntries = useMemo(() => {
    const entries: ObjectChangeLogEntry[] = []

    objectChangeLogs.forEach((log) => {
      log.objectFieldChangeList?.forEach((change) => {
        entries.push({
          createdByPersonId: log.createdByPersonId,
          createdByPersonName: log.createdByPersonName,
          createDttm: log.createDttm,
          fieldName: change.fieldName,
          fromValue: change.fromValue,
          toValue: change.toValue
        })
      })
    })

    return entries;
  }, [objectChangeLogs])

  return (
    <Grid {...rest}>
      <Grid.Col span={12}>
        <ObjectChangeLogDataTable
          withBorder
          records={objectChangeLogEntries}
          recordsPerPageOptions={[10, 25, 50, 75, 100]}
          fetching={isLoading || isFetching}
        />
      </Grid.Col>
    </Grid>
  )
}
